import {
    IFormSection, IFormField, IForm, SectionStatus,
    PickListItem, JsonItem,
    DateInputField, DateInputOptions,
    TextInputField, TextInputOptions,
    NumberInputField, NumberInputOptions,
    DropdownInputField, DropdownInputOptions,
    MultiAddInputField, MultiAddInputOptions,
    FileUploadInputField, FileUploadInputOptions
} from '../../../../../shared/components/web-form/web-form.objects';
import { SpecimenRequestInputField, SpecimenRequestInputOptions } from '../form-fields/specimen-request-input';
import { OtherTypeInputField } from '../form-fields/institution-other-input';
import { CurrentDropdownField } from '../form-fields/institution-type-dropdown';
import { ExternalColabField } from '../form-fields/external-colab';
import { UserQuery, StudyGroup } from '../../scripts/request-form.objects';

import { RecoverRequestForm } from '../scripts/request-form.form';

export class ContactInfoSection implements IFormSection {
    sectionId: string = "contact-info";
    displayName: string = "Contact Info";
    formFields: IFormField[]; 
    pickLists: JsonItem[];
    form: RecoverRequestForm;

    constructor() {

    }

    initialize(form: RecoverRequestForm) {
        this.form = form;
        this.pickLists = this.form.pickLists;

        let institutionTypePickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-institution-type").Json;


        let textInputFields: IFormField[] = [
            new TextInputField("ApplicationForm.RequestorFirstName", "", "requestor-first-name", "First Name", true),
            new TextInputField("ApplicationForm.RequestorLastName", "", "requestor-last-name", "Last Name", true),
            new TextInputField("ApplicationForm.InstitutionName", "", "institution-name", "Institution/Affiliation Name", true),
            new TextInputField("ApplicationForm.RequestorTelephone", "", "applicant-telephone", "Telephone", false),
            new TextInputField("ApplicationForm.RequestorEmail", "", "applicant-email", "Email", true, new TextInputOptions(-99, true)),
            new TextInputField("ApplicationForm.LetterAddressedTo", "", "letter-addressedto", "Letter Addressed To", false)
        ];

        textInputFields.forEach((field: TextInputField) => field.initialize(this));

        let dateVal = new Date();
        let formattedVal = dateVal.toISOString().split("T")[0];
        let dateInputFields: IFormField[] = [
            new DateInputField("ApplicationForm.LetterNeededByDate", formattedVal, "letter-neededby", "Letter Needed By Date", true)
        ]
        dateInputFields.forEach((field: DateInputField) => field.initialize(this));

        let otherFields: IFormField[] = [
            //new InstitutionTypeDropdownField("ApplicationForm.InstitutionTypeId", 0, "institution-type-select", "Institution Type", true, new DropdownInputOptions(false, institutionTypePickList)),
            //new InstitutionTypeInputField("ApplicationForm.InstitutionTypeOther", "", "other-institution-type-input", "Other Institution Type", false),
            new CurrentDropdownField("ApplicationForm.InstitutionTypeId", 0, "institution-type-select", "Institution Type", true, new DropdownInputOptions(false, institutionTypePickList), "-99", "#other-institution-type", "#other-institution-type-input"),
            new OtherTypeInputField("ApplicationForm.InstitutionTypeOther", "", "other-institution-type-input", "Other Institution Type", false, "#institution-type-select", "-99")
        ]
        otherFields.forEach(field => field.initialize(this));

        this.formFields = [...textInputFields, ...dateInputFields, ...otherFields];
    }

    updateSection() {
        this.triggerFormUpdate();
    }

    //            Get Status of the section
    getSectionStatus(): SectionStatus {
        let isValid = this.formFields.every(field => field.checkValid());
        if (isValid) return SectionStatus.Complete;

        let isInProgress = this.formFields.some(field => field.checkChanged());
        if (isInProgress) return SectionStatus.InProgress;

        return SectionStatus.NotStarted;
    }

    triggerFormUpdate() {
        if (this.form) {
            let status = this.getSectionStatus();
            this.form.triggerNavUpdate(this.sectionId, status);
        }
    }
}

export class ProjectDetailSection implements IFormSection {
    sectionId: string = "project-details";
    displayName: string = "Project Details";
    formFields: IFormField[];
    pickLists: JsonItem[];
    form: RecoverRequestForm;
    constructor() {
    }

    initialize(form: RecoverRequestForm) {
        this.form = form;
        this.pickLists = this.form.pickLists;

        let textInputFields: IFormField[] = [
            new TextInputField("ApplicationForm.ProjectTitle", "", "project-title", "Project Title", true),
            new TextInputField("ApplicationForm.ProjectShortTitle", "", "short-title", "Short Title", true, new TextInputOptions(-99, false, 50)),
            new TextInputField("ApplicationForm.CollaboratingInvestigators", "", "collaborating-investigators", "Collaborating RECOVER Investigators", false),
            new TextInputField("ApplicationForm.ExpertiseNeeded", "", "expertise-needed", "Relevant Areas of Expertise Needed", false),
            new TextInputField("ApplicationForm.Background", "", "background", "Background", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.ScientificAims", "", "scientific-aims", "Scientific Aims", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.Hypothesis", "", "hypothesis", "Hypothesis", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.RationaleImpact", "", "rationale-impact", "Scientific Rationale and Impact", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.Methods", "", "methods", "Methods/Approach", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.SampleSizePowerAnalysisApproach", "", "sample-size-power", "Sample Size, Power, and Analysis Approach", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.ParticipantDescription", "", "participant-description", "Participant Population Description/Phenotype", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.AssayDescription", "", "assay-description", "Assay Description", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.RelevantLiteratureReferences", "", "relevant-literature", "Relevant Literature References", false)
        ]
        textInputFields.forEach((field: TextInputField) => field.initialize(this));

        let biostatsupportPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-biostatistician-support").Json;
        let dropdownFields: IFormField[] = [
            new DropdownInputField("ApplicationForm.BiostatisticianSupportId", 0, "biostat-support", "Biostatistician Support", true, new DropdownInputOptions(false, biostatsupportPickList, false)),
        ];
        dropdownFields.forEach((field: DropdownInputField) => field.initialize(this));

        let multiAddFields: IFormField[] = [
            new MultiAddInputField("ApplicationForm.PINames", "", "pi-name-selection", "PI Names", true, new MultiAddInputOptions("No Principal Investigators added"))
        ]
        multiAddFields.forEach((field: MultiAddInputField) => field.initialize(this));

        this.formFields = [...textInputFields, ...multiAddFields, ...dropdownFields];
    }

    updateSection() {
        this.triggerFormUpdate();
    }

    // Get Status of the section
    getSectionStatus(): SectionStatus {
        let isValid = this.formFields.every(field => field.checkValid());
        if (isValid) return SectionStatus.Complete;

        let isInProgress = this.formFields.some(field => field.checkChanged());
        if (isInProgress) return SectionStatus.InProgress;

        return SectionStatus.NotStarted;
    }

    triggerFormUpdate() {
        if (this.form) {
            let status = this.getSectionStatus();
            this.form.triggerNavUpdate(this.sectionId, status);
        }
    }
}

export class AdminDetailsSection implements IFormSection {
    sectionId: string = "admin-details";
    displayName: string = "Admin Details";
    formFields: IFormField[];
    pickLists: JsonItem[];
    form: RecoverRequestForm;
    constructor() {
    }

    initialize(form: RecoverRequestForm) {
        this.form = form;
        this.pickLists = this.form.pickLists;

        let textInputFields: IFormField[] = [
            new TextInputField("ApplicationForm.SharingPlan", "", "sharing-plan", "Data and Sample Sharing Plan", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.BiospecimenUsageAbility", "", "biospecimen-usage", "Biospecimen Usage Ability", true, new TextInputOptions(-99, false, 250)),
            new TextInputField("ApplicationForm.FundingSources", "", "funding-sources", "Funding Sources", true, new TextInputOptions(-99, false, 250)),
            // TextInputField("ApplicationForm.ExternalCollaboratorsComment", "", "external-collaborators", "If Yes, Please Describe", false)
        ]
        textInputFields.forEach((field: TextInputField) => field.initialize(this));

        let dateVal = new Date();
        let formattedVal = dateVal.toISOString().split("T")[0];
        let dateInputFields: IFormField[] = [
            new DateInputField("ApplicationForm.StartDate", formattedVal, "start-date", "Anticipated project Start Date", true),
            new DateInputField("ApplicationForm.CompletionDate", formattedVal, "completion-date", "Anticipated project Completion Date", true)
        ]
        dateInputFields.forEach((field: DateInputField) => field.initialize(this));

        let yesNoPicklist: PickListItem[] = this.pickLists.find(list => list.Id == "pl-yes-no").Json;
        let fundingstatusPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-funding-status").Json;

        let dropdownFields: IFormField[] = [
            new DropdownInputField("ApplicationForm.HasExternalCollaboratorsId", 0, "external-collaborators-select", "Collaborators outside of the country?", true, new DropdownInputOptions(false, yesNoPicklist, false)),
            new ExternalColabField("ApplicationForm.ExternalCollaboratorsComment","","external-collaborators-comment","If Yes, Please Describe",false,"#external-collaborators-select","1","#external-collaborators-comment-block"),
            new DropdownInputField("ApplicationForm.FundingStatusId", 0, "funding-status-select", "Funding Status", true, new DropdownInputOptions(false, fundingstatusPickList, false))
        ];
        dropdownFields.forEach((field: DropdownInputField) => field.initialize(this));

        this.formFields = [...textInputFields, ...dateInputFields, ...dropdownFields];
    }

    updateSection() {
        this.triggerFormUpdate();
    }

    // Get Status of the section
    getSectionStatus(): SectionStatus {
        let isValid = this.formFields.every(field => field.checkValid());
        if (isValid) return SectionStatus.Complete;

        let isInProgress = this.formFields.some(field => field.checkChanged());
        if (isInProgress) return SectionStatus.InProgress;

        return SectionStatus.NotStarted;
    }

    triggerFormUpdate() {
        if (this.form) {
            let status = this.getSectionStatus();
            this.form.triggerNavUpdate(this.sectionId, status);
        }
    }
}

export class RequestHistoryEngagement implements IFormSection {
    sectionId: string = "history-engagement-details";
    displayName: string = "Request History and Engagement";
    formFields: IFormField[];
    pickLists: JsonItem[];
    form: RecoverRequestForm;

    constructor() {
    }

    initialize(form: RecoverRequestForm) {
        this.form = form;
        this.pickLists = this.form.pickLists;

        //let previousrequestPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-yes-no").Json;
        let yesNoPicklist: PickListItem[] = this.pickLists.find(list => list.Id == "pl-yes-no").Json;
        let requestTypePickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-new-resubmitted-request").Json;

        let textInputFields: IFormField[] = [
            new TextInputField("ApplicationForm.EngagementPlans", "", "engagement-plans", "Engagement Plans", false)
        ]

        let dropdownFields: IFormField[] = [
            new DropdownInputField("ApplicationForm.HasPreviousRequestId", 0, "has-previous-request", "Submitted any previous request", true, new DropdownInputOptions(false, yesNoPicklist, false)),
            new DropdownInputField("ApplicationForm.NewOrResubmittedRequestId", 0, "new-resubmitted-request", "New request or a resubmission of a previous request", true, new DropdownInputOptions(false, requestTypePickList, false))
        ];
        dropdownFields.forEach((field: DropdownInputField) => field.initialize(this));

        this.formFields = [...textInputFields, ...dropdownFields];
    }

    updateSection() {
        this.triggerFormUpdate();
    }

    // Get Status of the section
    getSectionStatus(): SectionStatus {
        let isValid = this.formFields.every(field => field.checkValid());
        if (isValid) return SectionStatus.Complete;

        let isInProgress = this.formFields.some(field => field.checkChanged());
        if (isInProgress) return SectionStatus.InProgress;

        return SectionStatus.NotStarted;
    }

    triggerFormUpdate() {
        if (this.form) {
            let status = this.getSectionStatus();
            this.form.triggerNavUpdate(this.sectionId, status);
        }
    }
}

export class BiospecimenRequestSection implements IFormSection {
    sectionId: string = "samples-request";
    displayName: string = "Biospecimens";
    formFields: IFormField[];
    pickLists: JsonItem[];
    form: RecoverRequestForm;

    constructor() {

    }

    initialize(form: RecoverRequestForm) {
        this.form = form;
        this.pickLists = this.form.pickLists;

        const studyGroupsItem = this.pickLists.find(x => x.Id === "study-groups");
        const userQueriesItem = this.pickLists.find(x => x.Id === "user-queries");

        let studyGroups: StudyGroup[] = (studyGroupsItem?.Json as StudyGroup[]) ?? [];
        let userQueries: UserQuery[] = (userQueriesItem?.Json as UserQuery[]) ?? [];


        let otherFields: IFormField[] = [
            new SpecimenRequestInputField(
                "BiospecimenRequests",
                [],
                "biospecimens-requested-container",
                "Biospecimen Requests",
                true,
                new SpecimenRequestInputOptions("biospecimen-request-modal", studyGroups, userQueries)
            )
        ];

        otherFields.forEach((field: SpecimenRequestInputField) => field.initialize(this));
        this.formFields = [...otherFields];
    }


    updateSection() {
        this.triggerFormUpdate();
    }

    // Get Status of the section
    getSectionStatus(): SectionStatus {
        let isValid = this.formFields.every(field => field.checkValid());
        if (isValid) return SectionStatus.Complete;

        let isInProgress = this.formFields.some(field => field.checkChanged());
        if (isInProgress) return SectionStatus.InProgress;

        return SectionStatus.NotStarted;
    }

    triggerFormUpdate() {
        if (this.form) {
            let status = this.getSectionStatus();
            this.form.triggerNavUpdate(this.sectionId, status);
        }
    }
}